interface Props {
  roundNumber: number;
  totalRounds: number;
}

const SketcherPreparingScreen: React.FC<Props> = ({ roundNumber, totalRounds }) => {
  return (
    <div className="sketcher-preparing">
      <div className="sketcher-preparing__content">
        <div className="sketcher-preparing__animation">
          <span className="sketcher-preparing__emoji">🎨</span>
          <div className="sketcher-preparing__dots">
            <span className="sketcher-preparing__dot" />
            <span className="sketcher-preparing__dot" />
            <span className="sketcher-preparing__dot" />
          </div>
        </div>
        <h2 className="sketcher-preparing__title">Preparing Art Gallery</h2>
        <p className="sketcher-preparing__subtitle">
          Collecting all the masterpieces from round {roundNumber} of {totalRounds}...
        </p>
        <div className="sketcher-preparing__loader">
          <div className="sketcher-preparing__loader-bar" />
        </div>
      </div>
    </div>
  );
};

export default SketcherPreparingScreen;
